import React from 'react'
import Frame1 from "../assets/client/Clients-01.png"
import Frame2 from "../assets/client/Clients-02.png"
import Frame3 from "../assets/client/Clients-03.png"
import Frame4 from "../assets/client/Clients-04.png"
import Frame5 from "../assets/client/Clients-05.png"
import Frame6 from "../assets/client/Clients-06.png"
import Frame7 from "../assets/client/Clients-07.png"
import Frame8 from "../assets/client/Clients-8.png"
import Frame9 from "../assets/client/Clients-09.png"
import Frame10 from "../assets/client/Clients-10.png"
import Frame11 from "../assets/client/Clients-11.png"
import Frame12 from "../assets/client/Clients-12.png"
import Frame13 from "../assets/client/Clients-13.png"
import Frame14 from "../assets/client/Clients-14.png"
import Frame15 from "../assets/client/Clients-15.png"
import Frame16 from "../assets/client/Clients-16.png"
import Frame17 from "../assets/client/Clients-17.png"
import Frame18 from "../assets/client/Clients-18.png"
import Frame19 from "../assets/client/Clients-19.png"
import Frame20 from "../assets/client/Clients-20.png"
import Frame21 from "../assets/client/Clients-21.png"
import Frame22 from "../assets/client/Clients-22.png"
import Frame23 from "../assets/client/Clients-23.png"
import Frame24 from "../assets/client/Clients-24.png"
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from 'react-slick'
import { Link } from 'react-router-dom'

const Client = () => {

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed : 2000
  };

  return (
        <div id='client-sec' className='py-12'>
   



    <div id='client-sec-2' className='bg-white px-48'>
        <div id='client-title' className='flex justify-between items-center'>
          <h2 className='text-black'>OUR <br/> <span>CLIENT</span> </h2>
          <p className='btn-1' id='about-btn' style={{margin:"0",height:"fit-content"}}><Link  to="/client">View More</Link></p>
        </div>

        <div className='client-carousel'>
        <Slider {...settings} >
        <div id='client-logo' style={{display:'flex'}} className='flex justify-between flex-wrap'>
         
         <div><img  src={Frame1} alt='vwrap'/></div>
          <div><img src={Frame2} alt='vwrap'/></div>
          <div><img src={Frame3} alt='vwrap'/></div>
          <div><img src={Frame4} alt='vwrap'/></div>
          <div><img src={Frame5} alt='vwrap'/></div>
          <div><img src={Frame6} alt='vwrap'/></div>
          <div><img src={Frame7} alt='vwrap'/></div>
          <div><img src={Frame8} alt='vwrap'/></div>
         </div>


         <div id='client-logo' className='flex justify-between flex-wrap'>
         
         <div><img  src={Frame9} alt='vwrap'/></div>
          <div><img  src={Frame10} alt='vwrap'/></div>
          <div><img  src={Frame11} alt='vwrap'/></div>
          <div><img  src={Frame12} alt='vwrap'/></div>
          <div><img  src={Frame13} alt='vwrap'/></div>
          <div><img  src={Frame14} alt='vwrap'/></div>
          <div><img  src={Frame15} alt='vwrap'/></div>
          <div><img  src={Frame16} alt='vwrap'/></div>
         </div>

         <div id='client-logo' className='flex justify-between flex-wrap'>
         
          <div><img src={Frame17} alt='vwrap'/></div>
          <div><img src={Frame18} alt='vwrap'/></div>
          <div><img src={Frame19} alt='vwrap'/></div>
          <div><img src={Frame20} alt='vwrap'/></div>
          <div><img src={Frame21} alt='vwrap'/></div>
          <div><img src={Frame22} alt='vwrap'/></div>
          <div><img src={Frame23} alt='vwrap'/></div>
          <div><img src={Frame24} alt='vwrap'/></div>
         </div>
  
         </Slider>
        </div>

        <div className='client-carousel-2'>
        <Slider {...settings} >
        <div id='client-logo' style={{display:'flex'}} className='flex justify-between flex-wrap'>
         
         <div><img  src={Frame1} alt='vwrap'/></div>
          <div><img src={Frame2} alt='vwrap'/></div>
          <div><img src={Frame3} alt='vwrap'/></div>
          <div><img src={Frame4} alt='vwrap'/></div>
         
         </div>


         <div id='client-logo' className='flex justify-between flex-wrap'>
         <div><img src={Frame5} alt='vwrap'/></div>
          <div><img src={Frame6} alt='vwrap'/></div>
          <div><img src={Frame7} alt='vwrap'/></div>
          <div><img src={Frame8} alt='vwrap'/></div>
        
          
         </div>

         <div id='client-logo' className='flex justify-between flex-wrap'>
         
         <div><img  src={Frame9} alt='vwrap'/></div>
          <div><img  src={Frame10} alt='vwrap'/></div>
          <div><img  src={Frame11} alt='vwrap'/></div>
          <div><img  src={Frame12} alt='vwrap'/></div>
         
         </div>

         <div id='client-logo' style={{display:'flex'}} className='flex justify-between flex-wrap'>
         
         <div><img  src={Frame13} alt='vwrap'/></div>
          <div><img  src={Frame14} alt='vwrap'/></div>
          <div><img  src={Frame15} alt='vwrap'/></div>
          <div><img  src={Frame16} alt='vwrap'/></div>
          
         </div>


         <div id='client-logo' style={{display:'flex'}} className='flex justify-between flex-wrap'>
         
         <div><img  src={Frame17} alt='vwrap'/></div>
          <div><img src={Frame18} alt='vwrap'/></div>
          <div><img src={Frame19} alt='vwrap'/></div>
          <div><img src={Frame20} alt='vwrap'/></div>
         
         </div>


         <div id='client-logo' style={{display:'flex'}} className='flex justify-between flex-wrap'>
         
         <div><img  src={Frame21} alt='vwrap'/></div>
          <div><img src={Frame22} alt='vwrap'/></div>
          <div><img src={Frame23} alt='vwrap'/></div>
          <div><img src={Frame24} alt='vwrap'/></div>
          
         </div>
  
         </Slider>
        </div>

        <div className='flex'>
        <p className='btn-2' id='about-btn' style={{marginBottom:"2rem",height:"fit-content"}}><Link to="/client">View More</Link></p>
        </div>
        
      </div>
    
    </div>
  )
}

export default Client
